import debug from 'debug';

import * as types from '../actions/users.types';

const log = debug('huddle:store:reducers:paymentInformation');

export const STORE_KEY = 'paymentInformation';

function paymentInformationReducer(state = {}, action = {}) {
  const { type, error, payload } = action;
  switch (type) {
    case types.USER_GET_PAYMENT_INFORMATION: {
      return payload;
    }

    default:
      return state;
  }
}

export default paymentInformationReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/paymentInformation.js